import { EntertainmentVideoStatus } from 'modules/entertainment-videos/types';
import { useSelector } from 'react-redux';
import type { State } from 'types';

export function useEntertainmentVideosForReview(
  pageType: 'offer' | 'content',
  offerId: number,
  deliverableId: number
) {
  const deliverables = useSelector((state: State) =>
    // eslint-disable-next-line no-nested-ternary
    (pageType === 'offer'
      ? state.offerDeliverables.deliverablesByOfferId[offerId]
      : pageType === 'content'
        ? state.campaignDeliverables.deliverables
        : [])
  );

  const currentDeliverable = deliverables.find((d) => d.id === deliverableId);

  return (currentDeliverable?.entertainmentVideos ?? []).filter(
    (video) =>
      video.entertainmentVideo.status !== EntertainmentVideoStatus.DRAFT
  );
}
